import React, { useEffect, useState } from "react";
import "../styles/TopNav.css";
import logo from "../assets/logo.png";

import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

import {
  db,
  getUserSettings,
  getWallet,
} from "../firebase";

import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
} from "firebase/firestore";

import {
  FaUserCircle,
  FaWallet,
  FaBars,
  FaClipboardList,
  FaBoxOpen,
} from "react-icons/fa";

import { FaStore } from "react-icons/fa6";

import { PiBuildingsFill } from "react-icons/pi";

export default function TopNav() {
  const { user } = useAuth();

  const [newOrders, setNewOrders] = useState(0);

  const [adShops, setAdShops] = useState([]);
const [currentAd, setCurrentAd] = useState(0);

  const [profileIncomplete, setProfileIncomplete] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname.startsWith(path);

  const [shop, setShop] = useState(null);

  const [profilePhoto, setProfilePhoto] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);

  const isMyShop =
  shop && location.pathname === `/shop/${shop.id}`;

const isProducts =
  shop &&
  location.pathname === `/shop/manage/${shop.id}`;

const isOrders =
  location.pathname === "/shop/orders";

  useEffect(() => {
  async function loadData() {

    try {

      // ========================================
      // Load shops for Top Nav Ads
      // This works even when user is logged out
      // ========================================

      const shopsSnap = await getDocs(
        collection(db, "shops")
      );

      const shopsForAds = shopsSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Premium shops
      const premiumShops = shopsForAds.filter(
        (shop) =>
          shop["Type (Premium/Normal)"] === "Premium"
      );

      // Normal shops
      const normalShops = shopsForAds.filter(
        (shop) =>
          shop["Type (Premium/Normal)"] !== "Premium"
      );

      // Shuffle each group
      const shuffledPremium = [...premiumShops].sort(
        () => Math.random() - 0.5
      );

      const shuffledNormal = [...normalShops].sort(
        () => Math.random() - 0.5
      );

      // Premium shops first
      setAdShops([
        ...shuffledPremium,
        ...shuffledNormal,
      ]);


      // ========================================
      // User-specific data
      // ========================================

      if (!user?.uid) return;


      // ========================================
      // User Profile
      // ========================================

      const profile = await getUserSettings(user.uid);

      setProfilePhoto(
        profile?.photoURL || user.photoURL || null
      );

      setDisplayName(
        profile?.name ||
        user.displayName ||
        "User"
      );


      // Check profile completeness
      setProfileIncomplete(
        !profile?.name ||
        !profile?.mobile ||
        !profile?.address ||
        !profile?.area
      );


      // ========================================
      // Wallet
      // ========================================

      const wallet = await getWallet(user.uid);

      setWalletBalance(
        wallet?.balance || 0
      );


      // ========================================
      // Find My Shop
      // ========================================

      const snap = await getDocs(
        query(
          collection(db, "shops"),
          where("uid", "==", user.uid)
        )
      );

      if (!snap.empty) {
        setShop({
          id: snap.docs[0].id,
          ...snap.docs[0].data(),
        });
      }

    } catch (err) {
      console.error(err);
    }
  }

  loadData();
}, [user]);

  useEffect(() => {
  if (!user) return;

  const q = query(
    collection(db, "shopOrders"),
    where("ownerUid", "==", user.uid),
    where("status", "==", "New")
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    setNewOrders(snapshot.size);
  });

  return unsubscribe;
}, [user]);

useEffect(() => {
  if (adShops.length <= 1) return;

  const timer = setInterval(() => {
    setCurrentAd((prev) => (prev + 1) % adShops.length);
  }, 4000);

  return () => clearInterval(timer);
}, [adShops]);

  return (
    <nav className="topnav">

      {/* Logo */}
      <div
        className="topnav-left"
        onClick={() => navigate("/home")}
      >
        <img
          src={logo}
          alt="Eyal"
          className="logo-img"
        />
      </div>

      {/* Right 
    <div className="topnav-right"> */}

    {/* Shop Advertisement */}
{adShops.length > 0 && adShops[currentAd] && (
  <div
    className="top-shop-ad"
    onClick={() =>
      navigate(`/shop/${adShops[currentAd].id}`)
    }
  >
    <div className="top-shop-ad-image">
      {adShops[currentAd]["Shop Image"] ? (
        <img
          src={adShops[currentAd]["Shop Image"]}
          alt={adShops[currentAd]["Shop Name"]}
        />
      ) : (
        <span>🏪</span>
      )}
    </div>

    <div className="top-shop-ad-content">
      <div className="top-shop-ad-title">
        {adShops[currentAd]["Shop Name"]}
      </div>

      <div
        className={`top-shop-ad-type ${
          adShops[currentAd]["Type (Premium/Normal)"] ===
          "Premium"
            ? "premium"
            : ""
        }`}
      >
        {adShops[currentAd]["Type (Premium/Normal)"] ===
        "Premium"
          ? "Premium"
          : "Featured Shop"}
      </div>

      <div className="top-shop-ad-meta">
        {adShops[currentAd].Location || ""}
        {adShops[currentAd].Category
          ? ` • ${adShops[currentAd].Category}`
          : ""}
      </div>
    </div>
  </div>
)}

     
        {/* All shops  
        <div
  className={`top-icon ${isActive("/shops") ? "active" : ""}`}
  onClick={() => navigate("/shops")}
>
  <PiBuildingsFill />
  <small>All Shops</small>
</div>
        */}
        {/* My Shop 
        <div
  className={`top-icon ${isMyShop ? "active" : ""}`}
  onClick={() => {
    if (shop) {
      navigate(`/shop/${shop.id}`);
    } else {
      navigate("/shops");
    }
  }}
>
  <FaStore />
  <small>My Shop</small>
</div>
*/}

        {/* Orders 
        <div
  className={`top-icon ${isOrders ? "active" : ""}`}
  onClick={() => {
    if (shop) {
      navigate("/shop/orders");
    } else {
      navigate("/shops");
    }
  }}
>
  <div className="top-icon-wrapper">
    <FaClipboardList />

    {newOrders > 0 && (
      <span className="top-badge">
        {newOrders > 99 ? "99+" : newOrders}
      </span>
    )}
  </div>

  <small>Shop Orders</small>
</div>
*/}
        {/* Wallet */}
        <div
  className="wallet-chip"
  onClick={() => navigate("/wallet")}
>
  <FaWallet className="wallet-chip-icon" />
  <span>₹{walletBalance}</span>
</div>

        {/* Profile */}
       <div
  className="profile-button"
  onClick={() =>
    navigate(user ? "/user/profile" : "/login")
  }
>
  {profilePhoto ? (
    <img
      src={profilePhoto}
      alt={displayName}
      className="profile-pic"
    />
  ) : (
    <FaUserCircle className="default-user-icon" />
  )}

  {profileIncomplete && (
    <span className="profile-notification"></span>
  )}
</div>

        {/* Menu 
        <button
          className="menu-button"
          onClick={() => navigate("/more")}
        >
          <FaBars />
        </button>
*/}
     {/* </div>*/}

    </nav>
  );
}